export const APP_PATHS = Object.freeze({
  LANDING: { url: "/", label: "الرئيسية" },
  POLICY: { url: "/privacy-policy", label: "سياسة الخصوصية" },
  LOGIN: { url: "/login", label: "تسجيل الدخول" },
  HOME: { url: "/home", label: "الرئيسية" },
  PENDING_ORDERS: { url: "/pending-orders", label: "جارٍ توصيله" },
  PRICED_ORDERS: { url: "/priced-orders", label: "تم تسعيره" },
  PRICED_ORDER_ITEMS: {
    url: "/priced-orders/:orderId",
    label: "منتجات تم تسعيرها",
  },
  CATEGORIES: { url: "/categories", label: "الأقسام الرئيسية" },
  SKUS: { url: "/skus", label: "المنتجات" },
  BUNDLES: { url: "/bundles", label: "عروض التوفير" },
  NEW_SKUS: { url: "/new-skus", label: "جديد من موتور" },
  RECOMMENDED_SKUS: { url: "/recommended-skus", label: "منتجات عشانك" },
  PROMOTIONS: { url: "/promotions", label: "عروض و خصومات" },
  SKU_DETAILS: { url: "/skus/:skuId", label: "تفاصيل المنتج" },
  BUNDLE_DETAILS: { url: "/bundles/:bundleId", label: "تفاصيل المجموعة" },
  CART: { url: "/cart", label: "عربة التسوق" },
  VOICE_ORDER: { url: "/order/voice-order", label: "الطلب الصوتي" },
  PROFILE: { url: "/my-profile", label: "الملف الشخصي" },
  PREVIOUS_ORDERS: {
    url: "/my-profile/previous-orders",
    label: "طلباتي السابقة",
  },
  WALLET: { url: "/my-profile/wallet", label: "رصيدي" },
  NOT_FOUND: "*",
});
